// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-page-container {
  position: relative;
  padding: 1.8rem 1.8rem 0.5rem;
}
.app-page-container .setteingtheme-setting {
  width: 40px;
  height: 35px;
  background-color: var(--m-neutral);
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 50%;
  right: 0;
  cursor: pointer;
  transition: ease-in-out 0.2s;
  border-top-left-radius: var(--m-border-radius);
  border-bottom-left-radius: var(--m-border-radius);
}
.app-page-container .setteingtheme-setting svg {
  font-size: 18px;
  color: var(--m-white);
  animation: spin 2s linear infinite;
}
.app-page-container .custom-button {
  width: 100%;
}
.app-page-container .app-page-actions {
  flex-shrink: 0;
}
.app-page-container .app-page-actions .dropdown {
  width: auto;
}

@media (max-width: 991px) {
  .app-page-container .setteingtheme-setting {
    display: none;
  }
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/CustomUI/AppPage/style.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,6BAAA;AACJ;AACI;EACI,WAAA;EACA,YAAA;EACA,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,QAAA;EACA,QAAA;EACA,eAAA;EACA,4BAAA;EACA,8CAAA;EACA,iDAAA;AACR;AACQ;EACI,eAAA;EACA,qBAAA;EAEA,kCAAA;AACZ;AAGI;EACI,WAAA;AADR;AAII;EACI,cAAA;AAFR;AAIQ;EACI,WAAA;AAFZ;;AAOA;EAEQ;IACI,aAAA;EALV;AACF;AAmBA;EACI;IACE,uBAAA;EATJ;EAWE;IACE,yBAAA;EATJ;AACF","sourcesContent":[".app-page-container {\n    position: relative;\n    padding: 1.8rem 1.8rem .5rem; \n\n    .setteingtheme-setting {\n        width: 40px;\n        height: 35px;\n        background-color: var(--m-neutral);\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        position: fixed;\n        top: 50%;\n        right: 0;\n        cursor: pointer;\n        transition: ease-in-out .2s;\n        border-top-left-radius: var(--m-border-radius);\n        border-bottom-left-radius: var(--m-border-radius);\n\n        svg {\n            font-size: 18px;\n            color: var(--m-white);\n            -webkit-animation: spin 2s linear infinite;\n            animation: spin 2s linear infinite;\n        }\n    }\n\n    .custom-button {\n        width: 100%;\n    }\n\n    .app-page-actions {\n        flex-shrink: 0;\n\n        .dropdown {\n            width: auto;\n        }\n    }\n}\n\n@media (max-width: 991px) {\n    .app-page-container {\n        .setteingtheme-setting {\n            display: none;\n        }\n    }\n    \n}\n\n@-webkit-keyframes spin {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(360deg);\n    }\n  }\n\n@keyframes spin {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(360deg);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
